import React,{useState} from "react";
import "./SgpaComponent.css";
import { BsFillTrashFill } from "react-icons/bs";



function SgpaComponent(props) {


  return (
    <div className='sgpacomponent'>
      <input
        type="text"
        id="name"
        name="subjectName"
        placeholder={props.subject}
        className='inputsubject'
      />
        
        <div className="slider-container">
      <div className="slider-value">{props.credit}</div>
      <input
        className="slider-input"
        type="range"
        min={0}
        max={5}
        value={props.credit}
        onChange={(event) => props.handleCredits(event, props.index)}
      />
      <div className="slider-labels">
      <div className="slider-label" credits="0" >0</div>
        <div className="slider-label" credits="1" >1</div>
        <div className="slider-label" credits="2">2</div>
        <div className="slider-label" credits="3">3</div>
        <div className="slider-label" credits="4">4</div>
        <div className="slider-label" credits="5">5</div>
      </div>
    </div>

      
      <select
         className='grades'
        onChange={(event) => props.handleGrade(event, props.index)}
        grade={props.grade}
      > 
        <option grade="null">null</option>
        <option grade="O">O</option>
        <option grade="A+">A+</option>
        <option grade="A">A</option>
        <option grade="B+">B+</option>
        <option grade="B">B</option>
        <option grade="C">C</option>
        <option grade="F">F</option>
        <option grade="ab">ab</option>
        <option grade="I">I</option>
      </select>
      <button className="deletebtn" onClick={ () => props.handleDelete(props.index) }><BsFillTrashFill  size={18} /></button>
      
    </div>
  );
}

export default SgpaComponent;
